module.exports = __webpack_public_path__ + "img/mic_small.fa76c387.svg";